import { supabase } from '../../config/supabase';
import { Property } from '../../types/user';

export const getPropertyById = async (id: string): Promise<Property | null> => {
  const { data, error } = await supabase
    .from('properties')
    .select('*')
    .eq('id', id)
    .single();
  
  if (error) return null;
  
  return {
    id: data.id,
    name: data.name,
    location: data.location,
    ownerId: data.owner_id,
    stats: {
      revenue: data.stats?.revenue || 0,
      cleaningCosts: data.stats?.cleaning_costs || 0,
      inmohostCosts: data.stats?.inmohost_costs || 0,
      profit: data.stats?.profit || 0,
      occupancyRate: data.stats?.occupancy_rate || 0,
      reservations: data.stats?.reservations || 0,
      averageNightPrice: data.stats?.average_night_price || 0,
      averageStayDuration: data.stats?.average_stay_duration || 0
    },
    created_at: data.created_at
  };
};
